export const capitalizeFirst = (inputStr) =>  {
    if(inputStr) {
        inputStr = inputStr.trim()
        return inputStr[0].toUpperCase() + inputStr.slice(1).toLowerCase()
    }
    return ""
}